import { useFeatureFlagVariant } from "@/utils/kameleoon/useFeatureFlagVariant";
// For use in ContactProvider where context is not yet available
export function useIsFullNameForm(isPrivateOwner) {
    const fullNameFormVariant = "b";
    const isFullNameForm = useFeatureFlagVariant("cdp_full_name_form", fullNameFormVariant);
    // Only apply full name form for PRO listings (not private owners)
    return isFullNameForm && !isPrivateOwner;
}
